export const tickerItems = [
  '电报频道 · 3 分钟前发布了新内容',
  '微博 · 18 分钟前更新了今日动态',
  '推特 · 1 小时前同步了海外版本',
  '公众号 · 昨晚 21:40 推送了深度长文',
  '全渠道 · 今日已累计发布 12 条内容',
];

export const heroStats = [
  { label: '官方平台', value: '4', unit: '个' },
  { label: '累计关注', value: '115', unit: '万+' },
  { label: '每日更新', value: '12', unit: '次' },
];

export const socialAccounts = [
  {
    id: 'weibo',
    name: '黑料官方微博',
    handle: '@黑料官方',
    platform: '微博',
    icon: 'ri-weibo-fill',
    followers: '68.4 万',
    followersLabel: '粉丝',
    desc: '日常动态首发阵地，热点第一时间同步，配图与短评一应俱全。',
    actionLabel: '前往微博主页',
  },
  {
    id: 'wechat',
    name: '黑料官方公众号',
    handle: '黑料官方',
    platform: '公众号',
    icon: 'ri-wechat-fill',
    followers: '21.7 万',
    followersLabel: '关注',
    desc: '深读长文与周度盘点，节奏更慢、信息更全，适合安静地看完。',
    actionLabel: '搜索并关注',
  },
  {
    id: 'twitter',
    name: '黑料官方推特',
    handle: '@heiliaoofficial',
    platform: '推特',
    icon: 'ri-twitter-x-fill',
    followers: '15.3 万',
    followersLabel: 'Followers',
    desc: '面向海外同好，更新更快更全，重要内容优先在此同步。',
    actionLabel: '在推特上关注',
  },
  {
    id: 'telegram',
    name: '黑料官方电报',
    handle: '@heiliaoofficial_ch',
    platform: '电报',
    icon: 'ri-telegram-fill',
    followers: '9.6 万',
    followersLabel: '订阅',
    desc: '广播频道形式推送，开启通知后，任何一条新内容都不会漏掉。',
    actionLabel: '加入电报频道',
  },
];

export const feedItems = [
  {
    id: 'f1',
    platform: '微博',
    tag: 'ri-weibo-fill',
    time: '12 分钟前',
    title: '本周动态速览：三条内容已同步至全部渠道',
    excerpt:
      '从深夜的一条短评，到今早的长文复盘，本周黑料官方在四个渠道累计发布了七条内容。这条速览帮你把散落在不同平台的信息重新排成一条完整的时间线。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20style%20abstract%20art%20with%20warm%20crimson%20and%20amber%20gradient%20waves%20over%20textured%20cream%20paper%20background%2C%20minimal%20geometric%20shapes%2C%20soft%20studio%20lighting%2C%20muted%20warm%20tones%2C%20generous%20negative%20space%2C%20high%20detail&width=1200&height=800&seq=hlgl-feed-01&orientation=landscape',
    views: '2.4 万',
    comments: '186',
    likes: '1,203',
  },
  {
    id: 'f2',
    platform: '电报',
    tag: 'ri-telegram-fill',
    time: '1 小时前',
    title: '电报频道新增「只看重点」标签，长内容更好翻',
    excerpt:
      '电报频道的内容越来越多，这次给频道内的长内容加上了重点标签。打开频道后，你可以先扫一遍标签，再决定哪几条值得逐字读完。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20smoky%20charcoal%20editorial%20background%20with%20glowing%20amber%20accents%20and%20delicate%20grain%20texture%2C%20artistic%20non%20realistic%20composition%2C%20dramatic%20low%20key%20lighting%2C%20warm%20muted%20palette%2C%20high%20detail%2C%20premium%20magazine%20mood&width=1200&height=800&seq=hlgl-feed-02&orientation=landscape',
    views: '1.1 万',
    comments: '92',
    likes: '764',
  },
  {
    id: 'f3',
    platform: '公众号',
    tag: 'ri-wechat-fill',
    time: '昨天 21:40',
    title: '一篇长文：为什么我们决定把四个渠道都做起来',
    excerpt:
      '微博适合快，公众号适合慢，推特面向海外的读者，电报负责不漏消息。四个渠道各有分工，这篇长文讲清楚它们各自存在的理由。',
    cover:
      'https://readdy.ai/api/search-image?query=Vintage%20newspaper%20collage%20texture%20in%20warm%20beige%20and%20rust%20tones%2C%20layered%20paper%20edges%20and%20subtle%20ink%20stains%2C%20editorial%20magazine%20aesthetic%2C%20soft%20diffused%20light%2C%20artistic%20non%20realistic%20composition%2C%20high%20detail%2C%20generous%20negative%20space&width=1200&height=800&seq=hlgl-feed-03&orientation=landscape',
    views: '3.7 万',
    comments: '241',
    likes: '1,876',
  },
  {
    id: 'f4',
    platform: '推特',
    tag: 'ri-twitter-x-fill',
    time: '2 天前',
    title: '海外读者最常问的三个问题，一次性回答',
    excerpt:
      '推特后台收到最多的是关于更新时差、语言版本与内容范围的提问。这条把三个高频问题整理在一起，第一次关注的读者可以从这里开始看。',
    cover:
      'https://readdy.ai/api/search-image?query=Bold%20crimson%20brush%20stroke%20over%20cream%20canvas%20background%2C%20minimal%20modern%20editorial%20poster%20art%2C%20warm%20amber%20undertones%2C%20soft%20natural%20lighting%2C%20artistic%20abstract%20non%20realistic%20composition%2C%20high%20detail%2C%20calm%20elegant%20atmosphere&width=1200&height=800&seq=hlgl-feed-04&orientation=landscape',
    views: '9,860',
    comments: '58',
    likes: '512',
  },
];

export const talkStats = [
  { label: '本周讨论', value: '1,284' },
  { label: '新增评论', value: '356' },
  { label: '参与读者', value: '2,109' },
];

export const hotComments = [
  {
    id: 'c1',
    name: '老白不熬夜',
    platform: '来自 微博',
    avatar:
      'https://readdy.ai/api/search-image?query=Minimal%20editorial%20illustrated%20avatar%20of%20a%20calm%20reader%20in%20warm%20sepia%20and%20cream%20tones%2C%20soft%20studio%20lighting%2C%20plain%20neutral%20background%2C%20artistic%20non%20realistic%20style%2C%20high%20detail&width=160&height=160&seq=hlgl-ava-01&orientation=squarish',
    text: '跟着这条时间线看了一圈，终于搞清楚四个渠道的区别了。以前总以为发的东西是一样的。',
    time: '36 分钟前',
    likes: 328,
    replies: 24,
  },
  {
    id: 'c2',
    name: '折角书签',
    platform: '来自 公众号',
    avatar:
      'https://readdy.ai/api/search-image?query=Minimal%20editorial%20illustrated%20avatar%20of%20a%20thoughtful%20reader%20with%20warm%20rust%20accents%2C%20soft%20studio%20lighting%2C%20plain%20cream%20background%2C%20artistic%20non%20realistic%20style%2C%20high%20detail&width=160&height=160&seq=hlgl-ava-02&orientation=squarish',
    text: '长文那篇真的建议慢慢读，尤其是讲渠道分工的部分。原来电报只是为了不漏消息，难怪更新最勤。',
    time: '2 小时前',
    likes: 214,
    replies: 15,
  },
  {
    id: 'c3',
    name: '夜航船',
    platform: '来自 电报',
    avatar:
      'https://readdy.ai/api/search-image?query=Minimal%20editorial%20illustrated%20avatar%20of%20a%20quiet%20night%20reader%20in%20amber%20and%20warm%20brown%20tones%2C%20soft%20studio%20lighting%2C%20plain%20neutral%20background%2C%20artistic%20non%20realistic%20style%2C%20high%20detail&width=160&height=160&seq=hlgl-ava-03&orientation=squarish',
    text: '开了电报的通知之后，确实是四个渠道里最快收到消息的。想要第一时间知道的话直接订阅频道就好。',
    time: '5 小时前',
    likes: 167,
    replies: 9,
  },
];

export const timelineItems = [
  {
    time: '08:30',
    platform: '微博',
    title: '早间动态',
    desc: '一句短评配几张图，把今天值得留意的内容先摆出来。',
  },
  {
    time: '12:00',
    platform: '电报',
    title: '午间推送',
    desc: '把上午散落的信息打包成一条广播，方便快速扫读。',
  },
  {
    time: '18:45',
    platform: '推特',
    title: '海外同步',
    desc: '重要内容补上英文版本，同步给海外的读者。',
  },
  {
    time: '21:30',
    platform: '公众号',
    title: '深度长文',
    desc: '一整天的内容沉淀成一篇可以慢慢读的文章。',
  },
  {
    time: '23:00',
    platform: '全渠道',
    title: '当日汇总',
    desc: '四个渠道互相校验一遍，确认没有遗漏。',
  },
];

export const faqItems = [
  {
    q: '怎样才能第一时间看到黑料官方的更新？',
    a: '如果希望收到最及时的提醒，建议订阅黑料官方电报频道并开启通知；电报是所有渠道里推送最快的一个。习惯刷微博的读者关注黑料官方微博也同样能跟上节奏。',
  },
  {
    q: '四个平台发布的内容是一样的吗？',
    a: '不完全一样。微博偏快、偏短；公众号偏长、偏深度；推特面向海外读者，会补充语言版本；电报负责不漏消息，更新频率最高。四个渠道互为补充，并不是简单复制。',
  },
  {
    q: '公众号大概多久更新一次？',
    a: '公众号以深度内容为主，通常按周节奏更新，重要节点会额外加推。日常想看更密集的动态，可以直接看微博或电报频道。',
  },
  {
    q: '怎么确认自己关注的是官方账号？',
    a: '本页列出的四个账号即为黑料官方全平台矩阵，账号名称与 ID 均已核对。遇到名称相近但 ID 不同的账号，请以本页信息为准，避免误关注。',
  },
];

export const footerLinks = [
  { label: '社交矩阵', href: '#matrix' },
  { label: '最新动态', href: '#feed' },
  { label: '大家都在聊', href: '#talk' },
  { label: '更新节奏', href: '#timeline' },
  { label: '常见问题', href: '#faq' },
];